import { site, FLOOR_PLAN_PLACEHOLDER } from "@/data/site";

// Shared, template-generated defaults. Any project missing these fields
// inherits them automatically — so adding a new project only needs core data.

const DEFAULT_AMENITIES = [
    "Grand Arrival Lobby",
    "Infinity Sky Pool",
    "Fully-Equipped Fitness Studio",
    "Private Banquet & Lounge",
    "Landscaped Podium Gardens",
    "Children's Play Zone",
    "Co-working Business Suite",
    "Spa & Wellness Centre",
    "24×7 Concierge & Security",
    "EV Charging Bays",
    "Multipurpose Sports Court",
    "Rooftop Observation Deck",
];

const DEFAULT_HIGHLIGHTS = [
    "Prime micro-market with consistent capital appreciation",
    "Backed by a RERA-registered, credential-verified developer",
    "Strong rental demand from senior professionals and expatriates",
    "Proximity to upcoming infrastructure and transit corridors",
];

const DEFAULT_LOCATION_ADV = [
    { label: "Metro / Railway Station", time: "8 min" },
    { label: "International Airport", time: "20 min" },
    { label: "Premium Schools", time: "10 min" },
    { label: "Multi-speciality Hospital", time: "12 min" },
    { label: "Luxury Retail & Dining", time: "6 min" },
    { label: "Business District", time: "15 min" },
];

const DEFAULT_FAQ = [
    {
        q: "Is Swastik Realty a RERA-registered channel partner?",
        a: "Yes. Swastik Realty operates as an authorised, RERA-registered channel partner and works directly with the developer on this project.",
    },
    {
        q: "Are the prices shown final?",
        a: "Indicative pricing is shown for guidance. Request the latest price sheet and our advisors will share the current, all-inclusive costing.",
    },
    {
        q: "Can you arrange a site visit?",
        a: "Absolutely. We arrange discreet, chauffeured private site visits at a time that suits you — simply tap Book Site Visit.",
    },
    {
        q: "Do you assist with home loans and documentation?",
        a: "Yes. We provide complete end-to-end assistance including loan facilitation, legal due-diligence and registration.",
    },
];

const snapshotFrom = (p) => ({
    Configuration: p.configurations,
    "Price Range": p.priceRange || p.startingPrice,
    Possession: p.possession,
    Developer: p.developer,
    Location: p.location,
    MahaRERA: p.maharera || site.rera,
});

const aboutDeveloperFrom = (p) => {
    const match = site.developers.find((d) => d.name === p.developer);
    return {
        name: p.developer,
        blurb:
            (match && match.note) ||
            `${p.developer} is among the developers Swastik Realty partners with to bring you verified, best-in-class residences across Mumbai.`,
        image: (match && match.image) || p.image,
    };
};

export const withDefaults = (p) => ({
    ...p,
    heroImage: p.heroImage || p.image,
    overview:
        p.overview || [
            `${p.name} by ${p.developer} is a distinguished residential address in ${p.location}, thoughtfully designed for those who value space, light and enduring quality.`,
            `Offering ${p.configurations} homes, the development pairs considered architecture with a curated suite of lifestyle amenities — a rare balance of privacy, convenience and long-term value.`,
        ],
    plans: (p.plans || []).map((pl) => ({
        floorPlan: FLOOR_PLAN_PLACEHOLDER,
        ...pl,
    })),
    gallery: p.gallery && p.gallery.length ? p.gallery : site.galleryPool,
    amenities: p.amenities && p.amenities.length ? p.amenities : DEFAULT_AMENITIES,
    highlights: p.highlights && p.highlights.length ? p.highlights : DEFAULT_HIGHLIGHTS,
    locationAdvantages:
        p.locationAdvantages && p.locationAdvantages.length
            ? p.locationAdvantages
            : DEFAULT_LOCATION_ADV,
    faq: p.faq && p.faq.length ? p.faq : DEFAULT_FAQ,
    snapshot: snapshotFrom(p),
    aboutDeveloper: aboutDeveloperFrom(p),
    brochure: p.brochure || "#",
    mapQuery: p.mapQuery || p.location,
    maharera: p.maharera || site.rera,
});

export const listProjects = () => site.projects.map(withDefaults);
export const getProject = (id) => {
    const p = site.projects.find((x) => x.id === id);
    return p ? withDefaults(p) : null;
};
